import React from 'react';
import { Card, Typography } from 'antd';
import { CarOutlined, UserOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const { Title, Text } = Typography;

// Style constants
const BORDER_STYLE = '1px solid #f0f0f0';
const WrapperCard = styled(Card)`
	border-radius: 8px;
	margin-bottom: 16px;
	border: ${BORDER_STYLE};
`;

const CardHeader = styled.div`
	padding: 16px 24px;
	border-bottom: ${BORDER_STYLE};
`;

const CardTitle = styled(Title)`
	&& {
		margin: 0;
	}
`;

const CardBody = styled.div`
	padding: 24px;
`;

const InfoBlock = styled.div`
	background-color: #f9f9f9;
	border: ${BORDER_STYLE};
	padding: 16px;
	border-radius: 8px;
	margin-bottom: 16px;
	display: flex;
	align-items: center;
`;

const IconWrapper = styled.div`
	background-color: #e6f7ff;
	padding: 12px;
	border-radius: 6px;
	margin-right: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const InfoTitle = styled(Title)`
	&& {
		margin: 0;
	}
`;

const InfoSubText = styled(Text)`
	&& {
		font-size: 12px;
	}
`;

// Marks a vehicle borrowed from a vendor other than the trip's billing vendor.
const CrossVendorTag = styled.span`
	display: inline-block;
	margin-top: 6px;
	padding: 2px 8px;
	border-radius: 4px;
	font-size: 12px;
	font-weight: 500;
	background-color: #ffe7d899;
	color: #e46802;
`;

function VehicleDriverCard({ vehicle, driver, isCrossVendor, vehicleVendorName }) {
	return (
		<WrapperCard bodyStyle={{ padding: '0px' }}>
			<CardHeader>
				<CardTitle level={5}>Vehicle and Driver Details</CardTitle>
			</CardHeader>

			<CardBody>
				<InfoBlock>
					<IconWrapper>
						<CarOutlined style={{ color: '#1890ff', fontSize: '20px' }} />
					</IconWrapper>
					<div>
						<InfoTitle level={5}>{vehicle?.vehicle_number}</InfoTitle>
						<InfoSubText type="secondary">{vehicle?.vehicle_type}</InfoSubText>
						{isCrossVendor && (
							<CrossVendorTag>Belongs to : {vehicleVendorName}</CrossVendorTag>
						)}
					</div>
				</InfoBlock>
				<InfoBlock>
					<IconWrapper>
						<UserOutlined style={{ color: '#1890ff', fontSize: '20px' }} />
					</IconWrapper>
					<div>
						<InfoTitle level={5}>{driver?.driver_name}</InfoTitle>
						<InfoSubText type="secondary">{driver?.driver_number}</InfoSubText>
					</div>
				</InfoBlock>
			</CardBody>
		</WrapperCard>
	);
}

VehicleDriverCard.propTypes = {
	vehicle: PropTypes.object,
	driver: PropTypes.object,
	isCrossVendor: PropTypes.bool,
	vehicleVendorName: PropTypes.string,
};

export default VehicleDriverCard;
